import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import React from 'react';
import axios from 'axios';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import LocationInput from '../../../../shared/google-location-input/LocationInput';
import { Countries } from '../../../../constants/Countries';
import LocationMap from '../../../../shared/google-map/LocationMap';
import { validateAlphanumeric } from '../../../../utils/formUtils';

const ActivityLocation = ({ locationFormData, setLocationFormData, getAlllocationData }) => {
  const onChangePostalCode = (e) => {
    if (e.value) {
      const isValid = validateAlphanumeric(e.value);
      if (!isValid) return false;
    }
    setLocationFormData({ postalCode: e });
  };

  const onLocationSelect = async (locObj) => {
    let addressLine1 = '';
    let addressLine2 = '';
    let country = '';
    let state = '';
    let postalCode = '';
    let city = '';
    const latitude = locObj?.geometry?.location.lat();
    const longitude = locObj?.geometry?.location.lng();
    let timeZone = '';
    const currFormData = { ...locationFormData };

    locObj.address_components.forEach((item) => {
      if (item.types.includes('street_number')) {
        addressLine1 = item.long_name;
        return;
      }

      if (item.types.includes('route')) {
        addressLine1 += ` ${item.long_name}`;
        return;
      }

      if (item.types.includes('neighborhood') && item.types.includes('political')) {
        addressLine2 = item.long_name;
        return;
      }

      if (item.types.includes('country') && item.types.includes('political')) {
        country = item.long_name;
        return;
      }

      if (item.types.includes('administrative_area_level_1') && item.types.includes('political')) {
        state = item.long_name;
        return;
      }

      if (item.types.includes('postal_code')) {
        postalCode = item.long_name;
        return;
      }

      if (item.types.includes('locality') && item.types.includes('political')) {
        city = item.long_name;
      }
    });

    try {
      const timeInSecs = new Date().getTime() / 1000;
      const res = await axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude}%2C${longitude}&timestamp=${timeInSecs}&key=AIzaSyAa_UAQQDPYFCyHvbDG4rlkxFYk1vgLFkM`,
      );

      if (res.data && res.data.status === 'OK' && res.data.timeZoneName) {
        timeZone = res.data.timeZoneName;
      }
    } catch (err) {
      console.error(err);
    }

    currFormData.addressLine1.value = addressLine1 || locObj.vicinity;
    currFormData.addressLine2.value = addressLine2;
    currFormData.country.value = country;
    currFormData.state.value = state;
    currFormData.postalCode.value = postalCode;
    currFormData.city.value = city;
    currFormData.latitude.value = latitude;
    currFormData.longitude.value = longitude;
    currFormData.timeZone.value = timeZone;
    setLocationFormData(currFormData);
  };

  return (
    <div className='row px-3 w-100 d-flex '>
      <div className='row'>
        <div className='custom-upload col-md-12'>
          <RadioGroup
            row
            aria-label={'hotel'}
            onChange={(e) => {
              setLocationFormData({
                hotel: {
                  ...locationFormData?.hotel,
                  value: e.target.value,
                },
              });
            }}
            value={locationFormData?.hotel?.value}
            name={'hotel'}
            className='document-type mb-3'
          >
            <FormControlLabel
              value='hotel'
              control={<Radio color='primary' />}
              label='Hotel'
              className='me-5'
            />
            <FormControlLabel
              value='external'
              control={<Radio color='primary' />}
              label='External'
              className='me-5'
            />
            <FormControlLabel
              value='url'
              control={<Radio color='primary' />}
              label='Online'
              className='me-5'
            />
          </RadioGroup>
        </div>

        {locationFormData?.hotel?.value === 'hotel' && (
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomSelect
                item={locationFormData?.hotelLocation}
                handleInputChange={(e) => {
                  setLocationFormData({ hotelLocation: e });
                }}
                labelField='name'
                valueField='id'
                options={[...getAlllocationData]}
                hideNullOption={true}
              />
            </div>
          </div>
        )}
        {locationFormData?.hotel?.value === 'external' && (
          <div className='col-md-12 mb-3'>
            <h4 className='tabs-title'>Location</h4>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <LocationInput onLocationSelect={onLocationSelect} />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.addressLine1}
                  handleInputChange={(e) => {
                    setLocationFormData({ addressLine1: e });
                  }}
                  maxLength='150'
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.addressLine2}
                  handleInputChange={(e) => {
                    setLocationFormData({ addressLine2: e });
                  }}
                  maxLength='150'
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={locationFormData?.country}
                  handleInputChange={(e) => {
                    setLocationFormData({ country: e });
                  }}
                  labelField='name'
                  valueField='name'
                  labelPrefix='Select'
                  options={Countries}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.state}
                  handleInputChange={(e) => {
                    setLocationFormData({ state: e });
                  }}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.postalCode}
                  handleInputChange={(e) => onChangePostalCode(e)}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.city}
                  handleInputChange={(e) => {
                    setLocationFormData({ city: e });
                  }}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.latitude}
                  handleInputChange={(e) => {
                    setLocationFormData({ latitude: e });
                  }}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.longitude}
                  handleInputChange={(e) => {
                    setLocationFormData({ longitude: e });
                  }}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.area}
                  handleInputChange={(e) => {
                    setLocationFormData({ area: e });
                  }}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={locationFormData?.timeZone}
                  handleInputChange={(e) => {
                    setLocationFormData({ timeZone: e });
                  }}
                />
              </div>
            </div>
            <div className='row'>
              <div
                className={`col-md-12 ${
                  !(locationFormData?.latitude && locationFormData?.longitude)
                    ? 'disabled-container'
                    : ''
                }`}
              >
                <LocationMap
                  lat={locationFormData?.latitude?.value}
                  lng={locationFormData?.longitude?.value}
                />
              </div>
            </div>
          </div>
        )}

        {locationFormData?.hotel?.value === 'url' && (
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={locationFormData?.urlTitle}
                handleInputChange={(e) => {
                  setLocationFormData({ urlTitle: e });
                }}
                label={locationFormData?.urlTitle?.fieldName}
                multiline={true}
                required={locationFormData?.urlTitle?.validations?.includes('required')}
                maxLength='36'
                endAdornment={true}
                characterCount={true}
                error={!!locationFormData?.urlTitle?.errors?.required}
                helperText={
                  locationFormData?.urlTitle?.errors?.required && 'This field is required'
                }
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={locationFormData?.url}
                handleInputChange={(e) => {
                  setLocationFormData({ url: e });
                }}
                label={locationFormData?.url?.fieldName}
                multiline={true}
                required={locationFormData?.url?.validations?.includes('required')}
                error={!!locationFormData?.url?.errors?.required}
                helperText={locationFormData?.url?.errors?.required && 'This field is required'}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityLocation;
